var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-kn",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M151.69-.347h745.12v745.12H151.69z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-104.23 .239) scale(.68714)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe900",
    d: "M-5.3 0h1073.5v744.09H-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.838 0l1.246 536.41L830.738-.35-5.832 0z",
    fill: "#35a100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.5 744.09l-1.9-557.75-842.62 558.17 844.52-.42z",
    fill: "#c70000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.3 576.85l.708 167.92 182.28-.24 890.3-596.88-1-146L886.848 0-5.332 576.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M818.048 269.088l-64.225-2.242-25.28 60.153-14.313-61.51-64.235-2.152 55.38-35.764-14.425-61.479 48.54 39.402 55.323-35.853-25.377 60.121zm-400.58 260.38l-64.225-2.242-25.28 60.153-14.313-61.51-64.235-2.152 55.38-35.764-14.425-61.479 48.54 39.402 55.323-35.853-25.377 60.121z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKn);
export default __webpack_public_path__ + "static/media/kn.035ea8e73dcd9287c4f3fd369bc96ab8.svg";
export { ForwardRef as ReactComponent };